import ApplicationController from './application_controller'

/**
 * Contrôleur générique pour basculer entre options radio
 * Gère l'affichage/masquage des sections selon l'option sélectionnée
 * Peut être réutilisé pour différents cas d'usage avec des options à basculer
 */
export default class extends ApplicationController {
  static targets = [
    "firstRadio", 
    "secondRadio", 
    "firstFields", 
    "secondFields",
    "firstLabel",
    "secondLabel"
  ]

  connect() {
    this.updateVisibility()
  }

  toggle() {
    this.updateVisibility()
  }

  selectFirst() {
    this.firstRadioTarget.checked = true
    this.secondRadioTarget.checked = false
    this.updateVisibility()
  }

  selectSecond() {
    this.secondRadioTarget.checked = true
    this.firstRadioTarget.checked = false
    this.updateVisibility()
  }

  updateVisibility() {
    const isFirstSelected = this.firstRadioTarget.checked

    if (isFirstSelected) {
      // Afficher la première section, masquer la seconde
      this.showElement(this.firstFieldsTarget)
      this.hideElement(this.secondFieldsTarget)
      // Visibilité des labels
      this.showElement(this.firstLabelTarget)
      this.hideElement(this.secondLabelTarget)
    } else {
      // Masquer la première section, afficher la seconde
      this.hideElement(this.firstFieldsTarget)
      this.showElement(this.secondFieldsTarget)
      // Visibilité des labels
      this.showElement(this.secondLabelTarget)
      this.hideElement(this.firstLabelTarget)
    }
  }

  showElement(element) {
    if (element.classList.contains('hidden')) {
      element.classList.remove('hidden')
    }
  }

  hideElement(element) {
    if (!element.classList.contains('hidden')) {
      element.classList.add('hidden')
    }
  }
} 